// extracted by mini-css-extract-plugin
module.exports = {"clients":"clients-module--clients--2YrID","brands":"clients-module--brands--9WoZk"};